import { nanoid } from "@reduxjs/toolkit";
import React, { FC, useEffect } from "react";
import { formatMoney, formatPhone } from "shared/plugins/string-helper";
import moment from "moment-timezone";
import "./order-success.less";
import { shallowEqual, useSelector } from "react-redux";
import { momentDateTimeFormat } from "shared/plugins/localization";
import { RootState } from "app.store";

const OrderSuccessPage: FC = (props) => {
  const currentBranch = useSelector(
    (state: RootState) => state.shoppingCart.shoppingCart.branch,
    shallowEqual
  );

  const model = useSelector(
    (state: RootState) => state.order.confirmCheckoutSuccessModel,
    shallowEqual
  );

  useEffect(() => {
    document.title = "Order Success";
  }, []);
  return (
    <section id="order-success-page" className="p-2 bg-white">
      <h2 className="title text-center text-bold m-bot-3">
        <p>Thanks For Your Order</p>
        {`${model?.firstName} ${model?.lastName}`.toUpperCase()}
      </h2>
      <div className="section-body ">
        <div className="item-success">
          <h3 className="h">Location:</h3>
          <div className="text-bold">{model?.branch?.name}</div>
        </div>
        <div className="section-content py-2">
          <h2 className="h5 font-semibold py-2">Order Confirmation</h2>
          {model?.orderItems?.map((m) => (
            <div className="item-success flex justify-between" key={nanoid()}>
              <h3 className="h font-semibold">
                {m.product?.name} | {formatMoney(m.price, 2, ".", ",", "$")}
                <div className="modifiers font-normal">
                  {m.modifiers?.map((mo) => (
                    <span key={nanoid()}>{mo.product?.name} | {formatMoney(mo.price * mo.quantity, 2, ".", ",", "$")}</span>
                  ))}
                </div>
                <div className="qty">
                  Qty: {m.quantity}
                </div>
              </h3>
              <div className="price font-bold">
                {formatMoney((m.price + m.modifiers.map((mo) => mo.price * mo.quantity).reduce((a, b) => a + b, 0)) * m.quantity, 2, ".", ",", "$")}
              </div>
            </div>
          ))}
        </div>
        <div className="section-total  py-2">
          <h2 className="h5 font-semibold py-2">Summary</h2>
          <div className="item-success flex justify-between ">
            <h3 className="h font-semibold">Subtotal</h3>
            <div className="price font-semibold">
              {formatMoney(model?.subTotal, 2, ".", ",", "$")}
            </div>
          </div>
          <div className="item-success flex justify-between">
            <h3 className="h font-semibold">Discount</h3>
            <div className="price font-semibold">
              {formatMoney(model?.discountAmount, 2, ".", ",", "$")}
            </div>
          </div>
          <div className="item-success flex justify-between">
            <h3 className="h font-semibold">Shipping</h3>
            <div className="price font-semibold">
              {formatMoney(model?.shippingFee, 2, ".", ",", "$")}
            </div>
          </div>
          <div className="item-success flex justify-between">
            <h3 className="h font-semibold">Taxes</h3>
            <div className="price font-semibold">
              {formatMoney(model?.taxes, 2, ".", ",", "$")}
            </div>
          </div>
          {model?.additionalTaxes?.map((m, index) => (
            <div key={index} className="item-success flex justify-between">
              <h3 className="h font-semibold">{m.taxName}</h3>
              <div className="price font-semibold">
                {formatMoney(m.feeAmount, 2, ".", ",", "$")}
              </div>
            </div>
          ))}
          <div className="item-success flex justify-between">
            <h3 className="h font-semibold">Convenient fee</h3>
            <div className="price font-semibold">
              {formatMoney(model?.nonCashAdjFee, 2, ".", ",", "$")}
            </div>
          </div>
          <div className="item-success flex justify-between">
            <h3 className="h font-semibold">Tips</h3>
            <div className="price font-semibold">
              {formatMoney(model?.tip, 2, ".", ",", "$")}
            </div>
          </div>
          <div className="item-success flex justify-between">
            <h3 className="h font-semibold">Total</h3>
            <div className="price font-semibold">
              {formatMoney(model?.totalAmount, 2, ".", ",", "$")}
            </div>
          </div>
        </div>
        {model?.orderShippings[0] && (
          <div className="section-information border-t pt-2">
            <h2 className="h5 font-bold py-2">Billing Information</h2>
            <div className="item-success flex justify-between">
              <h3 className="h">Order Number:</h3>
              <div className="text-bold">{model?.orderNumber}</div>
            </div>
            <div className="item-success flex justify-between">
              <h3 className="h">Request pickup time:</h3>
              <div className="text-bold">
                {moment(model.orderShippings[0].requestedPickupTime)
                  .tz(currentBranch.ianaTimeZone)
                  .format(momentDateTimeFormat())}
              </div>
            </div>
            <div className="item-success flex justify-between">
              <h3 className="h">Payment method:</h3>
              <div className="text-bold">Credit Card</div>
            </div>

            {model?.orderPayments.length > 0 && (
              <>
                <div className="item-success flex justify-between">
                  <h3 className="h">Name:</h3>
                  <div className="text-bold">
                    {`${model?.orderPayments[0].billingAddress.firstName} ${model?.orderPayments[0].billingAddress.lastName}`.toUpperCase()}
                  </div>
                </div>
                <div className="item-success flex justify-between">
                  <h3 className="h">Phone:</h3>
                  <div className="text-bold">
                    {formatPhone(model?.phoneNumber)}
                  </div>
                </div>
                {model?.orderPayments[0].billingAddress.countryCode !== "" && model?.orderPayments[0].billingAddress.countryCode !== null && (
                  <div className="item-success flex justify-between">
                    <h3 className="h">Address:</h3>
                    <div className="text-bold text-right">
                      {`${model?.orderPayments[0].billingAddress.street},`}
                      <br />
                      {`${model?.orderPayments[0].billingAddress.provinceName}, `}
                      {`${model?.orderPayments[0].billingAddress.stateCode}, `}
                      {`${model?.orderPayments[0].billingAddress.postalCode}`}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <div className="section-footer text-center mt-4">
        {model?.email && (
          <p className="pb-4">Please check your mail box: {model?.email}</p>
        )}
        <a className="uppercase btn--primary p-2" href="/">
          Go Homepage
        </a>
      </div>
    </section>
  );
};

export default OrderSuccessPage;
